import React, { useEffect, useState } from "react";
import { Card, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

interface ActivityState {
  activity: any;
}

const MyCasesActivity = ({ activity }: ActivityState) => {
  //upcoming
  const [birthdays, setBirthdays] = useState(activity.upcoming_birthdays || []);
  const [meetings, setMeetings] = useState(activity.upcoming_meetings || []);
  //recent activity
  const [newCases] = useState(activity.recently_assigned_cases || []);
  const [updatedHousehold] = useState(activity.recently_updated_household || []);
  const [banned] = useState(activity.recently_banned || []);
  const [newNotes] = useState(activity.recently_created_notes || []);
  const [assignedBeds] = useState(activity.recently_assigned_beds || []);

  function formatDate(dateStr: string) {
    if (!dateStr) return "";

    const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateStr);
    const iso = isDateOnly ? `${dateStr}T00:00:00` : dateStr;
    const date = new Date(iso);

    if (isDateOnly) {
      return date.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
      });
    } else {
      return date.toLocaleString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    }
  }

  useEffect(() => {
    setBirthdays(
      activity.upcoming_birthdays?.map((bday: any) => ({
        ...bday,
        birthdate_formatted: formatDate(bday.birthdate),
      })) || [],
    );
  }, [activity.upcoming_birthdays]);

  useEffect(() => {
    setMeetings(
      activity.upcoming_meetings?.map((meeting: any) => ({
        ...meeting,
        meeting_date_formatted: formatDate(meeting.start_at),
      })) || [],
    );
  }, [activity.upcoming_meetings]);

  const activityCard = (title: string, type: string, data: any[]) => {
    return (
      <div key={type}>
        <h6 className="app-orange-text">{title}</h6>
        <Stack gap={2} className="align-items-start mb-3">
          {data.map((act: any, index: number) => (
            <Card className="card-case-activity p-0 button w-100 hover-link" key={`${act?.id}${index}`}>
              <Link key={`${act?.id}${index}`} to={`/my-cases/${act?.id}`} className="text-decoration-none">
                <div className="ms-3 my-2 d-flex justify-content-between align-items-center">
                  <span className="hover-link w-100">
                    <text className="app-header-text">
                      {type === "new"
                        ? act?.name
                        : type === "household"
                          ? act?.username
                          : type === "notes" && act?.subject_name
                            ? `${act?.name} for ${act?.subject_name}`
                            : type === "notes"
                              ? act?.name
                              : type === "meetings"
                                ? act?.participant_name || act?.main_contact_name || act?.case_name
                                : act?.username}
                    </text>
                  </span>
                  <span className="w-100 text-end me-3">
                    <FontAwesomeIcon icon={faUpRightFromSquare} className="hover-icon me-3" />
                    <text className="app-light-gray-text">
                      {type === "new"
                        ? "Assigned by " + act?.username
                        : type === "household"
                          ? "Updated by " + act?.updated_username
                          : type === "banned"
                            ? "Banned by " + act?.banned_by_name
                            : type === "notes"
                              ? "Created by " + act?.username
                              : type === "beds"
                                ? "Assigned by " + act?.assigned_by_name
                                : type === "birthdays"
                                  ? "Birthday on " + act?.birthdate_formatted
                                  : type === "meetings"
                                    ? "Meeting on " + act?.meeting_date_formatted
                                    : ""}
                    </text>
                  </span>
                </div>
              </Link>
            </Card>
          ))}
        </Stack>
      </div>
    );
  };

  const upcoming = [
    activity?.upcoming_birthdays?.length > 0 && <>{activityCard("Birthdays This Week", "birthdays", birthdays)}</>,
    meetings?.length > 0 && <>{activityCard("Meetings This Week", "meetings", meetings)}</>,
  ].filter(Boolean);

  const recentActivity = [
    activity?.recently_assigned_cases?.length > 0 && <>{activityCard("New Cases", "new", newCases)}</>,
    activity?.recently_updated_household?.length > 0 && <>{activityCard("Household Updates by Others", "household", updatedHousehold)}</>,
    activity?.recently_banned?.length > 0 && <>{activityCard("Banned Household", "banned", banned)}</>,
    activity?.recently_created_notes?.length > 0 && <>{activityCard("New Notes by Others", "notes", newNotes)}</>,
    activity?.recently_assigned_beds?.length > 0 && <>{activityCard("Assigned a Bed", "beds", assignedBeds)}</>,
  ].filter(Boolean);

  return (
    <>
      <h4 className="hero-heading app-header-text">Upcoming</h4>
      {upcoming}
      <h4 className="hero-heading app-header-text">Recent Activity</h4>
      {recentActivity}
    </>
  );
};

export default MyCasesActivity;
